import { render } from "./SubscriptionPlan.vue?vue&type=template&id=49ae8a9e&scoped=true"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=ts"

import "./SubscriptionPlan.vue?vue&type=style&index=0&id=49ae8a9e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49ae8a9e"

export default script